import React, {useEffect, useState} from 'react';
import '@/generic-components/minimumPriceModal/_minimumPriceModal.scss'
import { softErroModalQuery } from '@/contentful/queries';
import { graphQLClient } from '@/contentful/contentful-config';
import SoftErrorModalContent from '@/components/error-boundary/SoftErrorModalContent';
import Modal from '@/generic-components/Modal';

const SoftErrorModal = (props: any) => {

  const {isShown, toggleSoftError} = props;

  const [modalCms, setModalCms] = useState<any>();
  
  useEffect(() => {
    const fetchModalContentFromCms = async () => {
      try {
        const response = await graphQLClient.request(softErroModalQuery);
        const errorModalCms = response;
        setModalCms({ errorModalCms });
      } catch (error) {
        console.log(error);
      }
    }
    fetchModalContentFromCms();
  }, []);
  
  return (
    <Modal
    errorModal={true}
    isShown={isShown}
    hide={toggleSoftError}
    headerText = {modalCms?.errorModalCms?.simoSoftErrorModalCollection?.items[0]?.title}
    modalContent={
      <SoftErrorModalContent cms={modalCms?.errorModalCms?.simoSoftErrorModalCollection?.items[0]} onCancelButton={toggleSoftError} />
    }
  />
  )
};

export default SoftErrorModal;
